import { root } from './archive';

export const archive = {
  ...root,
};
